const home: Record<string, string> = {
  'brand.name': 'Ark of Hope',
  'brand.full': 'African and Canadian Community Ark of Hope',
  'brand.fullFr': 'Arche de l’espoir des communautés africaines et canadiennes',
  'brand.tagline': 'A Safe Harbour. A Fair Path. A Stronger Future.',
  'brand.descriptor': 'A bilingual nonprofit advancing equity, dignity, opportunity and belonging for women, newcomers, families and underserved communities.',
  'brand.long': 'African and Canadian Community Ark of Hope is a bilingual, community-based nonprofit organization working to remove systemic barriers and strengthen the social and economic well-being of women, girls, newcomers, families, persons with disabilities and other equity-deserving communities.',
  'site.email': 'african.canadian.arkofhope@gmail.com',
  'site.skip': 'Skip to main content',

  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.work': 'Our Work',
  'nav.ark': 'The Credentials ARK',
  'nav.impact': 'Impact and Systems Change',
  'nav.partners': 'Partners',
  'nav.involved': 'Get Involved',
  'nav.news': 'News and Resources',
  'nav.contact': 'Contact',
  'nav.donate': 'Donate',
  'nav.langFr': 'Français',
  'nav.langEn': 'English',
  'nav.langAria': 'Switch language between French and English',
  'nav.menu': 'Open menu',
  'nav.close': 'Close menu',

  'film.alt': 'Low over the sea at dawn, spray bursting into a community hall where chairs are set in a circle, people gathering at tables in gold light, and the lit hall beside still water at blue hour.',
  'b1.stamp': 'A Safe Harbour. A Fair Path. A Stronger Future.',
  'b1.h': 'Building equitable pathways<br>where people can <em class="accent">belong</em>, contribute and thrive.',
  'b1.sub': 'A bilingual nonprofit advancing equity, dignity, opportunity and belonging for women, newcomers, families and underserved communities.',
  'b1.cta': 'Explore Our Work',
  'b1.cta2': 'Get Involved',
  'b2.stamp': 'African and Canadian Community Ark of Hope',
  'b2.h': 'A Safe Harbour.<br>A Fair Path.<br>A <em class="accent">Stronger</em> Future.',
  'b2.sub': 'African and Canadian Community Ark of Hope is a bilingual, community-based nonprofit organization working to remove systemic barriers and strengthen the social and economic well-being of women, girls, newcomers, families, persons with disabilities and other equity-deserving communities.',
  'b2.chip1': 'English · Français',
  'b2.chip2': 'Community-led',
  'b2.chip3': 'Systems change',
  'b2.cta': 'Get Involved',

  'manifesto.text': 'Hope becomes [[powerful]] when it is joined with opportunity, dignity and practical action.',
  'welcome.p1': 'We work alongside communities, not simply for them, to create fairer systems, stronger networks and sustainable pathways to participation and leadership.',
  'welcome.p2': 'Through culturally responsive engagement, education, advocacy, mentorship and partnership, we help turn lived experience into community-informed solutions.',

  'hm.focus.eyebrow': 'Our Focus',
  'hm.focus.h': 'Our <em class="accent">focus</em>.',
  'hm.focus.p': 'Five interconnected areas guide our program development and partnerships.',
  'hm.focus.link': 'See our work',
  'hm.focus.cta': 'Explore Our Work',
  'focus.1t': 'Women’s equality and leadership',
  'focus.1p': 'Advancing safety, economic security, representation and decision-making power for diverse women and girls.',
  'focus.2t': 'Newcomer and professional inclusion',
  'focus.2p': 'Addressing barriers related to international credentials, Canadian experience, professional networks and equitable advancement.',
  'focus.3t': 'Youth and family well-being',
  'focus.3p': 'Strengthening resilience, skills, belonging and access to community supports.',
  'focus.4t': 'Accessibility and disability inclusion',
  'focus.4p': 'Promoting accessible participation and removing attitudinal, communication and institutional barriers.',
  'focus.5t': 'Bilingual community engagement',
  'focus.5p': 'Serving English- and French-speaking communities and meaningfully engaging Francophone official-language minority communities.',

  'hm.change.eyebrow': 'How We Create Change',
  'hm.change.h': 'How we create <em class="accent">change</em>.',
  'hm.change.p1': 'We listen to those most affected, bring institutions and communities to the same table, co-design practical solutions, and support organizations to change the policies and practices that sustain inequality.',
  'hm.change.p2': 'Our goal is not to ask people to adapt to unfair systems. Our goal is to help make the systems fair.',
  'hm.change.cta': 'Impact and Systems Change',

  'hm.ark.eyebrow': 'Signature Initiative',
  'hm.ark.tag': 'Under development',
  'hm.ark.h': 'The Credentials<br><em class="accent">ARK</em>.',
  'hm.ark.p': 'Removing systemic barriers for newcomer and racialized professional women. The initiative is under development and focuses on changing systems rather than asking women to carry the full burden of overcoming discriminatory barriers.',
  'hm.ark.cta': 'Learn about The Credentials ARK',

  'hm.close.eyebrow': 'Join Us',
  'hm.close.h': 'Together, we can move<br>from barriers to <em class="accent">belonging</em>.',
  'hm.close.p': 'Whether you are a community member, volunteer, employer, professional association, educational institution, funder or service provider, there is a place for you in this work.',
  'hm.close.b1': 'Partner With Us',
  'hm.close.b2': 'Volunteer',
  'hm.close.b3': 'Donate',

  'hm.about.eyebrow': 'Who We Are',
  'hm.about.h': 'A safe harbour, built <em class="accent">with community</em>.',
  'hm.about.p1': 'African and Canadian Community Ark of Hope is a bilingual nonprofit organization committed to advancing gender equality, inclusion and sustainable community well-being.',
  'hm.about.p2': 'We connect community knowledge with professional expertise and cross-sector partnerships to build solutions that are practical, measurable and sustainable.',
  'hm.about.link': 'About Us',
  'hm.about.link2': 'Our Work',
  'hm.about.alt': 'Women of different ages and backgrounds talking around a table in a bright community hall',
  'hm.about.cap': 'Our work is rooted in respect for human dignity and in the belief that lasting change happens when communities are heard.',

  'hm.step.eyebrow': 'Our Approach',
  'hm.step.h': 'Six steps from listening to <em class="accent">lasting change</em>.',
  'hm.step.p': 'Community knowledge and institutional action, brought together in one purposeful process.',
  'hm.step.link': 'Impact and Systems Change',

  'hm.part.eyebrow': 'Take Part',
  'hm.part.h': 'There is a place for you in <em class="accent">this work</em>.',
  'hm.part.p': 'Whether you are a community member, volunteer, employer, professional association, educational institution, funder or service provider, there is a place for you in this work.',
  'hm.part.c1t': 'Volunteer',
  'hm.part.c1p': 'Volunteers help extend the reach of our work and strengthen the communities we serve.',
  'hm.part.c1l': 'Volunteer with us',
  'hm.part.c2t': 'Partner with us',
  'hm.part.c2p': 'No single organization can dismantle systemic barriers alone.',
  'hm.part.c2l': 'Explore partnership',
  'hm.part.c3t': 'Share your experience',
  'hm.part.c3p': 'Your experience can help shape better solutions to credential, employment and leadership barriers.',
  'hm.part.c3l': 'Share your experience',
  'hm.part.c4t': 'Donate',
  'hm.part.c4p': 'Every contribution helps create a fairer path for women, newcomers, families and underserved communities.',
  'hm.part.c4l': 'Support the work',

  'hm.news.eyebrow': 'News and Resources',
  'hm.news.h': 'Updates, resources and <em class="accent">learning</em>.',
  'hm.news.p': 'This section will share organizational updates, community opportunities, learning resources, project findings, bilingual publications, partner announcements and stories of change.',
  'hm.news.note': 'Updates coming soon.',
  'hm.news.cta': 'News and Resources',
  'hm.news.cta2': 'Contact us',

  'ft.line': 'Advancing equity, dignity,<br>opportunity and <em class="accent">belonging</em>.',
  'ft.desc': 'Advancing equity, dignity, opportunity and belonging.',
  'ft.explore': 'Explore',
  'ft.more': 'More',
  'ft.contact': 'Contact',
  'ft.legal': 'Legal',
  'ft.privacy': 'Privacy',
  'ft.access': 'Accessibility',
  'ft.phone': '[Phone: to be added]',
  'ft.address': '[Mailing address: to be added]',
  'ft.hours': '[Service hours: to be added]',
  'ft.social': '[Social links: to be added]',
  'ft.rights': 'Copyright © African and Canadian Community Ark of Hope. All rights reserved.',

  'faq.eyebrow': 'Frequently Asked Questions',
  'faq.h': 'Questions, <em class="accent">answered</em>.',
  'faq.pending': '[Answer: to be added]',
  'faq.q1': 'Who does the organization serve?',
  'faq.q2': 'Are services available in English and French?',
  'faq.q3': 'Is The Credentials ARK an employment-placement service?',
  'faq.q4': 'How can an organization become a partner?',
  'faq.q5': 'Can I volunteer?',
  'faq.q6': 'Will I receive a charitable tax receipt for a donation?',

  'nf.stamp': '404',
  'nf.h': 'This page could not be found.',
  'nf.p': 'The address may have changed, or the page may not exist yet. Please use the menu, or return to the home page.',
  'nf.home': 'Return Home',

  'form.name': 'Name',
  'form.email': 'Email',
  'form.phone': 'Phone',
  'form.organization': 'Organization',
  'form.languages': 'Languages spoken',
  'form.availability': 'Availability',
  'form.accessibility': 'Accessibility needs',
  'form.message': 'Message',
  'form.preferred': 'Preferred language',
  'form.english': 'English',
  'form.french': 'Français',
  'form.consent': 'I consent to be contacted by African and Canadian Community Ark of Hope about this submission.',
  'form.required': 'Fields marked * are required.',
  'form.notice': 'We use your information only to respond to your request.',
  'form.send': 'Submit',
  'form.sending': 'Sending…',
  'form.ok': 'Thank you. Your message has been received and will go straight to our team.',
  'form.again': 'Send another message',
  'form.err': 'Your message could not be sent. Please try again in a moment, or write to us directly at african.canadian.arkofhope@gmail.com.',
  'form.vName': 'Please enter your name.',
  'form.vEmail': 'Please enter a valid email address.',
  'form.vMessage': 'Please write a short message (500 characters maximum).',
  'form.vRequired': 'Please complete the required fields.',
  'form.vConsent': 'Please confirm that we may contact you.',
};

export default home;